import axios from "axios";
import { HttpClient } from "../../../../httpClient";
// import {URL} from '../../../src/utils/config'
const eventTypeMap = {
  GB: "GET_HMRC_RESPONSE_MESSAGE",
  US: "GET_CBP_RESPONSE_MESSAGE",
  CA: "GET_CBSA_RESPONSE_MESSAGE",
};
class cbp {
  getCbpResponse = (payload, country) => {
    if (!payload) {
      return [];
    }
    let data = {
      eventMessage: {
        requestid: payload,
      },
      eventType: eventTypeMap[country],
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  };
  
  fetchCarmRecordById = (payload) => {
    let data = {
      eventMessage: {
        requestId: payload
      },
      eventTime: Date.now(),
      eventType: "GET_TRANSACTION_REQUEST_RESPONSE_CARM_BY_ID"
    }
    return HttpClient.custom({
      data,
    });
  }


}

export default new cbp();
